// Localhost http://localhost:3000/
// QA https://preprod.volvopenta.com/connect
// RC https://rc.volvopenta.com/connect
// Pre-RC https://black-sky-00dffdc03.6.azurestaticapps.net/
// PROD https://www.volvopenta.com/connect

export const isDev = window.location.hostname === 'localhost';

export const isQA = window.location.hostname.includes('preprod') || window.location.hostname.includes('localhost');

export const isPreRC = window.location.hostname.includes('black-sky');

export const isRC = window.location.hostname.includes('rc');

export const isProd = !isQA && !isRC && !isPreRC;
